import React from 'react';
import { CurtainsKind } from './curtains-kind';
import { CurtainsKindsSection } from './styles';
import { curtainsKinds } from './constants';

type Props = {
	openStoreSelectionModal: VoidFunction;
};

export const CurtainsKinds = ({ openStoreSelectionModal }: Props) => (
	<CurtainsKindsSection>
		{curtainsKinds.map(kind => (
			<CurtainsKind
				key={kind.text}
				dataQa={kind.dataQa}
				onModalButtonClick={openStoreSelectionModal}
				modalContentItems={kind.modalContentItems}
				imgUrls={kind.imgUrls}
				text={kind.text}
				modalButtonText={kind.modalButtonText}
				modalTitle={kind.modalTitle}
				modalImgUrl={kind.modalImgUrl}
				modalImgAlt={kind.modalImgAlt}
			/>
		))}
	</CurtainsKindsSection>
);
